module.exports = __webpack_public_path__ + "static/media/awad2.c9c8c392.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/awad2.png
// module id = 1309
// module chunks = 0